/* This is ment to build provide a quick starting point when starting new index type file */
import React from 'react';
import nextBackNavStyle from './style';

export default function NextBackNav({nextPressed, backPressed, nextSlideExzists, previousSlideExzists, mt, message}) {
	let style = nextBackNavStyle();

	return (
		<div id='next-back-nav' style={style.outerStyle({marginTop: mt})}>
			<p style={style.messageTextStyle()}>{message}</p>
			<div style={style.buttonContainerStyle()}>
				{previousSlideExzists() ? (
					<button style={style.buttonStyle({isBack: true})} onClick={backPressed}>
						Back
					</button>
				) : (
					<></>
				)}
				{nextSlideExzists() ? (
					<button style={style.buttonStyle()} onClick={nextPressed}>
						Next
					</button>
				) : (
					<></>
				)}
			</div>
		</div>
	);
}
